import Vue from 'vue'
import { URL_TEMPLATES } from '@/constants/urls.js'
import { LOT_TEMPLATE_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_TEMPLATE_MANAGEMENT.STATE.TEMPLATES_LIST]: null,
  [LOT_TEMPLATE_MANAGEMENT.STATE.CURRENT_TEMPLATE]: null,
  [LOT_TEMPLATE_MANAGEMENT.STATE.CREATED_LOT_ID]: null
}

const actions = {
  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.CREATE_LOT_FROM_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}/createLot`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CREATE_LOT_FROM_TEMPLATE, resp.data)
  },

  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.SAVE_AS_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },

  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.EDIT_LOT_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}`,
      model: model.lotTemplate
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.DELETE_LOT_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },

  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.GET_LOT_TEMPLATES] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_TEMPLATE_MANAGEMENT.MUTATIONS.GET_LOT_TEMPLATES, resp.data)
  },
  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_LOT_TEMPLATES] ({ commit }) {
    commit(LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_LOT_TEMPLATES)
  },
  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.GET_LOT_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_TEMPLATE_MANAGEMENT.MUTATIONS.GET_LOT_TEMPLATE, resp.data)
  },
  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_LOT_TEMPLATE] ({ commit }) {
    commit(LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_LOT_TEMPLATE)
  },
  async [LOT_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_LOTID] ({ commit }) {
    commit(LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_LOTID)
  }
}

const mutations = {
  [LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CREATE_LOT_FROM_TEMPLATE] (state, template) {
    state[LOT_TEMPLATE_MANAGEMENT.STATE.CREATED_LOT_ID] = template
  },
  [LOT_TEMPLATE_MANAGEMENT.MUTATIONS.GET_LOT_TEMPLATES] (state, template) {
    state[LOT_TEMPLATE_MANAGEMENT.STATE.TEMPLATES_LIST] = template
  },
  [LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_LOT_TEMPLATES] (state) {
    state[LOT_TEMPLATE_MANAGEMENT.STATE.TEMPLATES_LIST] = null
  },
  [LOT_TEMPLATE_MANAGEMENT.MUTATIONS.GET_LOT_TEMPLATE] (state, lot) {
    state[LOT_TEMPLATE_MANAGEMENT.STATE.CURRENT_TEMPLATE] = lot
  },
  [LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_LOT_TEMPLATE] (state) {
    state[LOT_TEMPLATE_MANAGEMENT.STATE.CURRENT_TEMPLATE] = null
  },
  [LOT_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_LOTID] (state) {
    state[LOT_TEMPLATE_MANAGEMENT.STATE.CREATED_LOT_ID] = null
  }
}

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations
}
